import {Provider} from './provider/Provider';

const LanguageService = {
  panelLanguage: () => {
    return Provider({
      methodName: "Api/Language/PanelLanguage",
    });
  },
  apiLanguages: () => {
    return Provider({
      methodName: "Api/Language/ApiLanguages",
    });
  },
  apiLanguage: () => {
    return Provider({
      methodName: "Api/Language/ApiLanguage",
    });
  },
  apiLanguagesDetails: () => {
    return Provider({
      methodName: "Api/Language/ApiLanguagesDetails",
    });
  },
};

export default LanguageService